import { APIService } from "../../../services/api";
import { API } from "@/lib/api";
import { settlementTypeHourlyRates } from "@/schemas/commonFields";
import { z } from "@/zod";

export type DepartmentBasedProjectSettlementTypes = z.infer<
  typeof settlementTypeHourlyRates
>;

const DepartmentBasedProjectService = new APIService<
  DepartmentBasedProjectSettlementTypes[],
  DepartmentBasedProjectSettlementTypes[]
>(API.DepartmentBasedProject);

export const DepartmentBasedProjectSettlementTypesService = {
  getList: () => {
    return DepartmentBasedProjectService.getList<
      DepartmentBasedProjectSettlementTypes[]
    >({}, "/settlement-types");
  },
};
